import { Item } from '@react-stately/collections';
import React__default from 'react';

/**
 * @subcomponent Listbox
 */ const ListboxOption = (props)=>{
    // this renders nothing, it does not get called, do not try and put anything in here
    return /*#__PURE__*/ React__default.createElement(Item, props);
};
// the Item component has some functions on it for the react-aria collection behavior.
// This will copy the props over
Object.assign(ListboxOption, Item);
ListboxOption.displayName = 'ListboxOption';

export { ListboxOption };
